export default __webpack_public_path__ + "static/media/card4.da39dcee.svg";